export const SET_EMBRYOLOGY_DATA = 'SET_EMBROLOGY_DATA';
export const RESET_EMBRYOLOGY_DATA = 'RESET_EMBROLOGY_DATA';
export const SET_EMBRYOLOGY_BIOPSY_FILES = 'SET_EMBRYOLOGY_BIOPSY_FILES';
export const DELETE_EMBRYOLOGY_BIOPSY_FILES = 'DELETE_EMBRYOLOGY_BIOPSY_FILES';
export const SET_EMBRYOLOGY_DAY_FILE = 'SET_EMBRYOLOGY_DAY_FILE';
export const DELETE_EMBRYOLOGY_DAY_FILE = 'DELETE_EMBRYOLOGY_DAY_FILE';
export const SET_EMBRYOLOGY_FROZEN_FILES = 'SET_EMBRYOLOGY_FROZEN_FILES';

export const setEmbryologyData = (keyPath, value) => ({
  type: SET_EMBRYOLOGY_DATA,
  payload: { keyPath, value },
});

export const setEmbryologyBiopsyFiles = (files) => ({
  type: SET_EMBRYOLOGY_BIOPSY_FILES,
  payload: files,
});
export const setEmbryologyFrozenFiles = (files) => ({
  type: SET_EMBRYOLOGY_FROZEN_FILES,
  payload: files,
});
export const deleteEmbryologyBiopsyFiles = (file) => ({
  type: DELETE_EMBRYOLOGY_BIOPSY_FILES,
  payload: file,
});

export const setEmbryologyDayFile = (day, index, file) => ({
  type: SET_EMBRYOLOGY_DAY_FILE,
  payload: {
    day,
    index,
    file,
  },
});

export const deleteEmbryologyDayFile = (day, index) => ({
  type: DELETE_EMBRYOLOGY_DAY_FILE,
  payload: {
    day,
    index,
  },
});

export const resetEmbryologyData = () => ({
  type: RESET_EMBRYOLOGY_DATA,
});
